const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];


export function tableDateFormate(date) {
    const dt = new Date(date);
    const d = new Intl.DateTimeFormat('en-US', { day: '2-digit' }).format(dt);
    const m = dt.getMonth()
    const y = new Intl.DateTimeFormat('en-US', { year: '2-digit' }).format(dt);

    const time = dt.toLocaleString([], { hour: '2-digit', minute: '2-digit', hour12: true });


    date = (`${d}-${monthNames[m]}-${y} ${time}`)

    return date;
}


export function onlyDateFormat(date) {
    const dt = new Date(date);
    const d = new Intl.DateTimeFormat('en-US', { day: '2-digit' }).format(dt);
    const m = dt.getMonth()
    const y = new Intl.DateTimeFormat('en-US', { year: '2-digit' }).format(dt);

    date = (`${d}-${monthNames[m]}-${y}`)

    return date;
}